// extracted by mini-css-extract-plugin
export default {"emptySearchPlaceholder":"empty-placeholder_emptySearchPlaceholder__O2toz","textGroup":"empty-placeholder_textGroup__cpKQX"};